import { Pipe, PipeTransform } from '@angular/core';
import { CustomerMap } from "../_models/crmStats";


@Pipe({
  name: 'customerpipe',
  pure: false
})
export class CustomerPipe implements PipeTransform {
  transform(items: CustomerMap[], filter: string): any {
    if (!items || !filter) {
      return items;
    }
    let multi = filter.split(' ');
    if (multi.length == 1) return items.filter(item => item.CRMName!=null && item.CRMName.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
    else {
      let res: CustomerMap[] = items.filter(item => item.CRMName != null && item.CRMName.toLowerCase().indexOf(multi[0].toLowerCase()) !== -1);
      for (let i = 1; i < multi.length; i++) {
        res = this.subfilter(res, multi[i]);
      }
      return res;
    }
  }
  subfilter(list:CustomerMap[],subfilter:string) {
    return list.filter(item => item.CRMName != null && item.CRMName.toLowerCase().indexOf(subfilter.toLowerCase()) !== -1);
  }
}



// WEBPACK FOOTER //
// E:/Release/InzuzoA/InzuzoA/src/app/pipes/customer.pipe.ts